<div class="container x-axis-no-padding" >

    <div class="d-flex flex-column flex-md-row align-items-center pb-4 mb-1 mt-4 left-alig no-padding">
      <a href="/" class="d-flex text-dark text-decoration-none">
        <img class="profile-img" src="../assets/logo.png">
      </a>
  
      <nav *ngIf="currentUrl=='/register'" class="d-inline-flex mt-2 mt-md-0 ms-md-auto center-aligners hidden-sm">
        <a class="me-3 py-2 text-dark text-decoration-none">Already an existing buisness?</a>
        <a class="me-3 py-2 text-dark text-decoration-none" [routerLink]="'/signin'">
          <button type="button" class="btn btn-primary primary-button" 
            style="border-radius: 80px;">
            Login
          </button>
        </a>
      </nav>
    </div>
    <div class="py-md-20 py-5 no-padding">
      <div class="container x-axis-no-padding">
  
        <div class="row" style="--bs-gutter-x: 0rem !important;">
          <div class="col-xl-6 col-lg-6 col-md-12">
            <div class="mb-4 mb-xl-0 text-center text-md-start">
  
              <div>
                <div class="card-body welcome-img">
                  <img src="../assets/business-person.png" class="business-person" />
                </div>
                <p class = "hidden-md-up px-4" style="
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 20px;
                display: flex;
                align-items: center;
                color: #0E0E0E;
                text-align: left;" id="hiddensm">Hello there! Welcome to
                  SwiftChat Business Manager</p>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12">
              <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>